import { Component } from 'react';
import { connect, MapDispatchToProps } from 'react-redux';
import Collapsible from '../../../Collapsible/Collapsible';
import Input from '../../../Input/Input';
import Textarea from '../../../Textarea/Textarea';
import {
  CustomIcon,
  Remove,
  SelectedImage,
  SignatureThumbContainer,
  ThumbImage,
  Size,
  SelectedInfo,
  Progress,
} from '../../../../containers/Tasks/CompanyManagement/CompanyDocuments/styles';
import Dropzone, { DropzoneRenderArgs } from 'react-dropzone';
import Button from '../../../Button/Button';
import { uriToBlob } from '../../../../utils/file';
import { display } from '../../../ErrorView/ErrorDialog';
import Toast from '../../../Notify';
import {
  item_createNewDocumentVersion,
  item_createNewDocumentVersionFn,
} from 'store/providers/providerSlice';
import document from 'assets/images/text.svg';
import {
  bytesToSize,
  convertDigitToProperFormat,
} from '../../../../utils/number';
import notify from '../../../Notify';
import { appDispatch } from 'store/store';
import { IDocumentView } from 'store/companies/companiesTypes';
import { IProviderDocumentViewObj } from 'store/providers/providerTypes';
import { WithTranslation, withTranslation } from 'react-i18next';

interface IDispatchToProps {
  addVersion: (
    file: any,
    fileName: string,
    name: string,
    message: string,
    itemId: number,
    onProgres: (p: number) => any
  ) => ReturnType<typeof item_createNewDocumentVersionFn>;
}
type IOwnProps = {
  item: IProviderDocumentViewObj;
};

type IComponentProps = IDispatchToProps & IOwnProps & WithTranslation;
interface IComponentState {
  name: string;
  message: string;
  file: IDocumentView | null;
  saving: boolean;
  progress: number;
}
class DocumentVersions extends Component<IComponentProps, IComponentState> {
  state = {
    file: null as IDocumentView | null,
    name: '',
    message: '',
    saving: false,
    progress: 0,
  };
  setDocument = (acceptedFile: File) => {
    const { name, size, type } = acceptedFile;
    const file: IDocumentView = {
      url: URL.createObjectURL(acceptedFile),
      fileSize: size,
      properties: {
        format: type.split('/')[1],
        displayName: name,
      },
    };
    this.setState({ file });
  };

  handleAcceptedFiles = (files: DropzoneRenderArgs['acceptedFiles']) => {
    const acceptedFile = files[0];
    this.setDocument(acceptedFile);
  };

  handleRejectedFiles = () => {
    const warningMessage = this.props.t('invalidFile');
    Toast(warningMessage, 'warning');
  };

  handleSave = async () => {
    const { item } = this.props;
    const { message, name, file } = this.state;
    this.setState({ saving: true });
    const blob = await uriToBlob(file!.url);
    const fileName = file!.properties.displayName;
    this.setState({ progress: 0 });
    this.props
      .addVersion(blob, fileName, name, message, item.id, (p: number) => {
        this.setState({ progress: p });
      })
      .then(
        () => {
          this.setState({ saving: false, name: '', message: '', file: null });
          this.setState({ progress: 0 });
          notify(this.props.t('versionUpdated'));
        },
        (error) => {
          display(error, false);
          this.setState({ saving: false });
        }
      );
  };

  render() {
    const { name, message, file, saving, progress } = this.state;
    return (
      <Collapsible header={<div>{this.props.t('addVersion')}</div>}>
        <div>
          <Input
            id="name"
            type="text"
            value={name}
            onChange={(e) => {
              this.setState({ name: e.target.value });
            }}
            placeholder={this.props.t('versionName')}
            label={this.props.t('versionName')}
          />
          <Textarea
            id="message"
            value={message}
            onChange={(e) => {
              this.setState({ message: e.target.value });
            }}
            placeholder={this.props.t('versionMessage')}
            label={this.props.t('versionMessage')}
          />
          {file ? (
            <SignatureThumbContainer
              style={{
                width: '100%',
                height: '100px',
                border: '1px solid black',
                borderRadius: '10px',
              }}
            >
              {
                <Remove
                  type="x"
                  color="red"
                  onClick={() => this.setState({ file: null })}
                />
              }
              <SelectedImage
                target="_blank"
                href={file!.url}
                rel="noopener noreferrer"
              >
                <ThumbImage src={document} />
                <SelectedInfo style={{ display: 'flex' }}>
                  <div>{file.properties.displayName}</div>
                  <Size>{bytesToSize(file.fileSize)}</Size>
                </SelectedInfo>
              </SelectedImage>
            </SignatureThumbContainer>
          ) : (
            <Dropzone
              style={{
                width: '100%',
                height: '100px',
                border: '1px solid lightGray',
                borderRadius: '10px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              multiple={false}
              onDropRejected={this.handleRejectedFiles}
              onDropAccepted={this.handleAcceptedFiles}
            >
              {/* @ts-expect-error JSX error*/}
              {() => (
                <div>
                  <div>{this.props.t('selectFile')}</div>
                  <CustomIcon type="file" />
                </div>
              )}
            </Dropzone>
          )}
          <Button
            style={{ marginTop: '10px' }}
            loading={saving}
            disabled={!file || !name}
            onClick={this.handleSave}
          >
            {this.props.t('send')}
          </Button>
          {saving && (
            <Progress>{`${convertDigitToProperFormat(progress)}٪`}</Progress>
          )}
        </div>
      </Collapsible>
    );
  }
}

const mapDispatchToProps: MapDispatchToProps<
  IDispatchToProps,
  IOwnProps
> = () => ({
  addVersion: (
    file: any,
    fineName: string,
    name: string,
    message: string,
    itemId: number,
    onProgress: (p: number) => any
  ) =>
    appDispatch(
      item_createNewDocumentVersion({
        providerItemId: itemId,
        file,
        filename: fineName,
        versionName: name,
        versionMessage: message,
        progressCallBack: onProgress,
      })
    ),
});

export default connect(
  null,
  mapDispatchToProps
)(withTranslation('modals')(DocumentVersions));
